import { AuthContext } from './context'
import PropTypes from 'prop-types'
import React from 'react'

class AuthBackground extends React.Component {

  static propTypes = {
    direction: PropTypes.string,
    children: PropTypes.node.isRequired
  }

  static defaultProps = {
    direction: 'forward'
  }

  // Generate random image number once when component is created
  _imageNumber = String(Math.floor(Math.random() * 22) + 1).padStart(2, '0')

  state = {
    shaking: false
  }

  _handleShake = this._handleShake.bind(this)

  render() {
    const { children } = this.props
    const { shaking } = this.state
    const backgroundImageUrl = `/images/signin/signin-${this._imageNumber}.jpg`
    return (
      <AuthContext.Provider value={{ shake: this._handleShake, shaking }}>
        <div className="maha-auth-background" style={{ backgroundImage: `url('${backgroundImageUrl}')` }}>
          <div className="maha-auth-wrapper">
            {children}
          </div>
        </div>
      </AuthContext.Provider>
    )
  }

  _handleShake() {
    this.setState({ shaking: true })
    setTimeout(() => {
      this.setState({ shaking: false })
    }, 500)
  }

}

export default AuthBackground
